import * as Yup from "yup";

import { createForm } from "../../../forms";

import type { TypeSafeReactLocalization } from "../../../../composites";

export type ACHPaymentRecipientFormType = {
  selectedRecipientId: API.RecipientId;
};

const translateValidationSchema = ({ getString }: TypeSafeReactLocalization) =>
  Yup.object().shape({
    selectedRecipientId: Yup.string().required(
      getString("form-generic-validation-required"),
    ),
  });

const initialValues: ACHPaymentRecipientFormType = {
  selectedRecipientId: "" as API.RecipientId,
};

// define form schema and validations
export const ACHPaymentRecipientForm = createForm({
  initialValues,
  translateValidationSchema,
});
